<script>
	import Accordion from './Accordion.svelte';

	const items = [
		{
			title: 'Disclaimer',
			content: `<p>I understand that if I no longer wish to receive text messages from WCU,
			I may revoke my consent at any time by texting back "Stop" to unsubscribe
			from the service. I understand that if I no longer wish to receive emails,
			I may revoke my consent at any time by clicking the "Unsubscribe" link
			within any email I receive from WCU. I understand I may revoke my consent
			to receive calls by informing any WCU associate calling me that I no
			longer want to receive calls from WCU.</p>`,
		},
	];
</script>

<div style="margin: 32px 0 0;">
	<p>
		By submitting this form, I provide my signature, expressly consenting to
		calls, prerecorded messages, emails and/or texts regarding my educational
		options from West Coast University using an automated dialing system to the
		number and email address provided. I understand my consent is not required
		to enroll at West Coast University, and that I can withdraw my consent at
		any time. To request information without consenting, please call
		866-508-2684. I also understand that I may revoke my consent at any time in
		accordance with WCU's Opt-Out Disclaimer Opt-Out Disclaimer. All information
		provided is subject to WCU's <a
			style="font-size: inherit;"
			href="/legal/privacy-policy">Privacy Policy</a
		>. This site is protected by reCAPTCHA and the Google Privacy Policy and
		Terms of Service apply. I acknowledge that the time zone in which I will
		receive marketing communications will be associated with the zip code I
		enter in this form. *Standard rates may apply.
	</p>
	<Accordion {items} />
</div>
